import { PLAYER_TRACKER_IMPRESSION, type PlayerTrackerImpressionName } from '@shared/tracking';

const WEEKLY_LIMIT_ERROR_KEYS = new Set(['aurumErrors_deposit_walletLimitInsufficient', 'aurumErrors_deposit_walletLimitReached']);

const LOOK_BACK_LIMIT_ERROR_KEYS = new Set(['aurumErrors_deposit_regulatoryLimitInsufficient', 'aurumErrors_deposit_regulatoryLimitReached']);

function normalisePaymentErrorKey(errorKey: string): string {
  return errorKey.replace(/\./g, '_');
}

/**
 * Maps Aurum pay-in limit error keys to VGCCC PTS impression names.
 * Weekly wallet limits → payment_internal_weekly_limit.
 * Regulatory / look-back limits → payment_look_back_limit.
 */
function getPaymentLimitImpressionName(errorKey?: string | null): PlayerTrackerImpressionName | undefined {
  if (!errorKey) return undefined;

  const normalisedKey = normalisePaymentErrorKey(errorKey);

  if (WEEKLY_LIMIT_ERROR_KEYS.has(normalisedKey)) {
    return PLAYER_TRACKER_IMPRESSION.PAYMENT_INTERNAL_WEEKLY_LIMIT;
  }

  if (LOOK_BACK_LIMIT_ERROR_KEYS.has(normalisedKey)) {
    return PLAYER_TRACKER_IMPRESSION.PAYMENT_LOOK_BACK_LIMIT;
  }

  return undefined;
}

export { getPaymentLimitImpressionName };
